
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 0a8 8 0 100 16A8 8 0 008 0zm3.311 14.032H9.077l-1.09-1.874-1.098 1.874H4.654l2.209-2.947-2.209-2.948H6.89l1.097 1.69 1.09-1.69h2.234l-2.207 2.948 2.208 2.947zm.073-6.202H9.149L8.06 5.956 6.96 7.83H4.727l2.208-2.947-2.208-2.948h2.234l1.097 1.69 1.091-1.69h2.235L9.175 4.883l2.209 2.947z","fill":"#000"}})])
          )
        }
      }
    